
<div class="p-0 m-0" :class="hidePageNumber ? 'd-flex align-items-center justify-content-between' : ''">
	<div class="counter" style="margin-right: 10px;">
		<span v-if="showDropdownPerPage" style="color: #848484;" class="d-flex align-items-center">
			<span>Showing</span>
			<CSelect style="min-width: 60px; max-width: fit-content !important;" @input="updatePerPage"
				v-model="perPageValue" :options="perPageOptions" :itemValue="'value'" :itemText="'text'" class="py-0 mx-2">
			</CSelect>
			<span>
				{{ perPageValue >= totalItems ? totalItems : showingItem.start }} - {{ perPageValue >= totalItems ? totalItems
					:
					showingItem.end }} of {{ totalItems }} {{ title }}
			</span>
		</span>
		<span v-else style="color: #848484;">
			Showing {{ perPageValue >= totalItems ? totalItems : showingItem.start }} - {{ perPageValue >= totalItems ?
				totalItems : showingItem.end }} of {{ totalItems }} {{ title }}
		</span>
	</div>

	<nav v-if="perPage < totalItems && !hidePageNumber" aria-label="Page navigation example">
		<ul class="pagination m-0 p-0 my-2">
			<li class="page-item" @click="setActivePage(0, 'navigation_first')" v-if="isActive != 1">
				<div class="page-link">
					<v-icon size="small" color="primary">mdi-chevron-double-left</v-icon>
					First
				</div>
			</li>
			<li class="page-item" @click="setActivePage(0, 'navigation_prev')" v-if="isActive != 1">
				<div class="page-link">
					<v-icon size="small" color="primary">mdi-chevron-left</v-icon>
					Prev
				</div>
			</li>
			<li v-for="page in pages" class="page-item" :class="isActive == page ? 'active' : ''">
				<a class="page-link" href="javascript:void(0)" @click="setActivePage(page)">{{ page }}</a>
			</li>
			<li class="page-item" @click="setActivePage(0, 'navigation_next')"
				v-if="isActive != totalPages && totalItems >= 1">
				<div class="page-link">
					Next
					<v-icon size="small" color="primary">mdi-chevron-right</v-icon>
				</div>
			</li>
			<li class="page-item" @click="setActivePage(0, 'navigation_last')"
				v-if="isActive != totalPages && totalItems >= 1">
				<div class="page-link">
					Last
					<v-icon size="small" color="primary">mdi-chevron-double-right</v-icon>
				</div>
			</li>
		</ul>
	</nav>
	<nav v-else-if="hidePageNumber" class="Page navigation example">
		<ul class="pagination m-0 p-0 my-2">
			<li class="" @click="setActivePage(0, 'navigation_prev')">
				<button :disabled="isActive == 1" role="button" class="btn btn-sm btn-outline-primary"
					:style="`border-color: ${primaryColor}; color: ${primaryColor}`">
					<v-icon size="small" color="primary">mdi-chevron-left</v-icon>
				</button>
			</li>
			<li class="ml-3" @click="setActivePage(0, 'navigation_next')">
				<button :disabled="!(isActive != totalPages && totalItems >= 1)" role="button"
					class="btn btn-sm btn-outline-primary" :style="`border-color: ${primaryColor}; color: ${primaryColor}`">
					<v-icon size="small" color="primary">mdi-chevron-right</v-icon>
				</button>
			</li>
		</ul>
	</nav>
</div>
